export const SidebarRow = {
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  minHeight: 'controlHCompact',
  padding: 'Z Z1',
  round: 'radiusControl',
  cursor: (el) => (el.onClick ? 'pointer' : 'default'),
  background: 'transparent',
  color: 'inactive',
  // Keyboard-operable when a consumer makes the row interactive (attaches
  // onClick). role + tabindex make it focusable so the global :focus-visible ring
  // engages; onKeydown mirrors the click on Enter/Space. Rows with no onClick
  // (display-only) stay plain (role/tabindex resolve to null).
  'data-sidebar-row': 'true',
  role: (el) => (el.onClick ? 'button' : null),
  tabindex: (el) => (el.onClick ? '0' : null),
  onKeydown: (e, el, s, ctx) => {
    // A nested More button owns its keyboard activation. Letting its key
    // bubble into the row also opened the section behind the menu.
    if (e.target !== el.node || e.defaultPrevented) return
    if ((e.key === 'Enter' || e.key === ' ') && el.onClick) {
      e.preventDefault()
      el.onClick(e, el, s, ctx)
    }
  },
  ':hover': { background: 'hover', color: 'title' },
  ':active': { background: 'selected', color: 'title' },
  ':focus-visible': { background: 'selected', color: 'title' },
  '@coarse': { minHeight: 'controlH' },

  Icon: {
    icon: (el) => el.parent?.icon || 'state',
    'aria-hidden': true,
    boxSize: 'A1 A1'
  },

  Label: {
    tag: 'span',
    fontSize: 'Z2',
    fontWeight: '500',
    flex: '1',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    text: (el) => el.parent?.label || ''
  },

  MoreBtn: {
    extends: 'SidebarItemMore'
  }
}
